import { render, staticRenderFns } from "./GhanaPhoneCallbackModal.vue?vue&type=template&id=20151428&scoped=true"
import script from "./GhanaPhoneCallbackModal.vue?vue&type=script&lang=js"
export * from "./GhanaPhoneCallbackModal.vue?vue&type=script&lang=js"
import style0 from "./GhanaPhoneCallbackModal.vue?vue&type=style&index=0&id=20151428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20151428",
  null
  
)

export default component.exports